export default (value = 0, digits = 0) =>
  value
    ? value.toLocaleString(undefined, {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
      })
    : 0;
